import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import PercentageInput from "../../PercentageInput/PercentageInput";
import TimePickerInput from "../../TimePickerInput/TimePickerInput";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import Switch from "../../Switch/Switch";
import List from "../../List/List";
import MultiSelect from "../../Selects/MultiSelect";
import BillingPolicyBuilderErrors from "../BillingPolicyBuilderErrors";

class BillingPolicyBuilderCancellationRules extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    // console.log("BillingPolicyBuilderCancellationRules", this.props);

    var tabClasses = clsx({
      active: this.props.active_tab == "cancellation_rules",
      "tab-pane": true,
    });

    if (this.props.read_only == false) {
      return (
        <div className={tabClasses} id="cancellation_rules">
          {this.renderErrors()}   
          {this.renderCancellationRulesForm()}
        </div>
      );
    } else {
      return (
        <div className={tabClasses} id="products">
          <label>{I18n.t("cancellation_rules")}</label>
          {this.props.cancellation_rules.length ? (
            <List
              header_primary={"name"}
              items={this.props.cancellation_rules}
              display_column_primary="name"
            />
          ) : (
            <div className="no-records">
              <span className="none">{I18n.t("none")}</span>
            </div>
          )}

        </div>
      );
    }
  }

  renderCancellationRulesForm() {
    var all_cancellation_rules = this.props.all_cancellation_rules;
    var inputs = [];
    for (var i = 0; i < all_cancellation_rules.length; i++) {
      var input = {
        label_primary: all_cancellation_rules[i].name,
        id: all_cancellation_rules[i].id,
      };
      inputs.push(input);
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <label>{I18n.t("cancellation_rules")}</label>
          {inputs.length ? (
            <MultiSelect
              header_primary="name"
              inputs={inputs}
              selected_inputs={this.props.cancellation_rule_ids}
              onChange={this.props.onChangeCancellationRules}
            />
          ) : (
            <div className="no-records">
              <span className="none">{I18n.t("none")}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  // renderFieldErrors(field) {
  //   if (this.props.errors && this.props.errors[field]) {
  //     var idx = 0;
  //     var errors = this.props.errors[field].map( (error) => {
  //       idx = idx + 1;
  //       return <li key={idx}><b>&#x2022;</b> {error}</li>;
  //     });
  //     return (
  //       <div className="help-block">
  //         <ul>{errors}</ul>
  //       </div>
  //     )
  //   }
  // }
  //
  // renderFieldClasses(field) {
  //   var classname = 'form-control';
  //   if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors['cancellation_rules']) {
  //     if (field == "refundable_until_time")
  //     classname = classname + ' has-errors';
  //   }
  //   return classname;
  // }

  renderErrors() {
    // console.log("this.props.errors", this.props.errors);
    var errors = BillingPolicyBuilderErrors.cancellation_rules(
      this.props.errors
    );

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }
}

export default BillingPolicyBuilderCancellationRules;
